import styled from "styled-components";
import { TablePageContent } from "components/TablePageLayout";
import { pxToRem } from "../../styles/utils";

export const AssignmentResponsesPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled(TablePageContent)`
  overflow-y: auto;
  margin-left: 0;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
  padding: ${pxToRem(32)} ${pxToRem(24)};

  /*
    Общий Table после первого рендера фиксирует измеренные auto-layout ширины
    через colgroup. Здесь задаём компактную стабильную раскладку вручную.
    Минимальная ширина таблицы не даёт «Статусу» и «Ответам» схлопнуться до
    размеров, при которых обрезаются бейдж и кнопка, а на широком экране эти
    колонки занимают только 9% и 8% соответственно.
  */
  table {
    table-layout: fixed !important;
    min-width: 1240px;
  }

  table > colgroup > col:nth-child(1) { width: 15% !important; }
  table > colgroup > col:nth-child(2) { width: 15% !important; }
  table > colgroup > col:nth-child(3) { width: 20% !important; }
  table > colgroup > col:nth-child(4) { width: 12% !important; }
  table > colgroup > col:nth-child(5) { width: 9% !important; }
  table > colgroup > col:nth-child(6) { width: 8% !important; }
  table > colgroup > col:nth-child(7) { width: 10% !important; }
  table > colgroup > col:nth-child(8) { width: 11% !important; }

  table > tbody > tr > td:nth-child(5),
  table > tbody > tr > td:nth-child(6) {
    padding-left: ${pxToRem(8)};
    padding-right: ${pxToRem(8)};
  }

  table > thead > tr > th:nth-child(5) > div,
  table > thead > tr > th:nth-child(6) > div {
    padding-left: ${pxToRem(8)};
    padding-right: ${pxToRem(8)};
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.ink};
`;

export const ResponseStatusCell = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const ResponseActionCell = styled.div`
  display: inline-flex;
  align-items: center;
`;
